/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MasterImportResponse } from '../model/masterImportResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DealershipControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingDELETE2(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingDELETE2(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingDELETE2(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingDELETE2(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Array<MasterImportResponse>>(`${this.basePath}/import/dealership/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingGET2(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingGET2(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingGET2(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingGET2(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MasterImportResponse>>(`${this.basePath}/import/dealership/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingHEAD2(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingHEAD2(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingHEAD2(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingHEAD2(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<Array<MasterImportResponse>>(`${this.basePath}/import/dealership/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingOPTIONS2(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingOPTIONS2(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS2(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS2(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<Array<MasterImportResponse>>(`${this.basePath}/import/dealership/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPATCH2(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPATCH2(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPATCH2(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPATCH2(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<Array<MasterImportResponse>>(`${this.basePath}/import/dealership/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPOST2(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPOST2(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPOST2(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPOST2(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Array<MasterImportResponse>>(`${this.basePath}/import/dealership/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPUT2(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPUT2(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPUT2(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPUT2(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<Array<MasterImportResponse>>(`${this.basePath}/import/dealership/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDealers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDealersUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDealersUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDealersUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDealersUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/dealership/dealers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDealers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDealersUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDealersUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDealersUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDealersUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/dealership/dealers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDealers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDealersUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDealersUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDealersUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDealersUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/dealership/dealers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDealers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDealersUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDealersUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDealersUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDealersUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/dealership/dealers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDealers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDealersUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDealersUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDealersUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDealersUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/dealership/dealers`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDealers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDealersUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDealersUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDealersUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDealersUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/dealership/dealers`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDealers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDealersUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDealersUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDealersUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDealersUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/dealership/dealers`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importExShowRoom
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importExShowRoomUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importExShowRoomUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importExShowRoomUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importExShowRoomUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/dealership/exshowroom`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importExShowRoom
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importExShowRoomUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importExShowRoomUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importExShowRoomUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importExShowRoomUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/dealership/exshowroom`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importExShowRoom
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importExShowRoomUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importExShowRoomUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importExShowRoomUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importExShowRoomUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/dealership/exshowroom`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importExShowRoom
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importExShowRoomUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importExShowRoomUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importExShowRoomUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importExShowRoomUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/dealership/exshowroom`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importExShowRoom
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importExShowRoomUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importExShowRoomUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importExShowRoomUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importExShowRoomUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/dealership/exshowroom`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importExShowRoom
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importExShowRoomUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importExShowRoomUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importExShowRoomUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importExShowRoomUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/dealership/exshowroom`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importExShowRoom
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importExShowRoomUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importExShowRoomUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importExShowRoomUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importExShowRoomUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/dealership/exshowroom`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importOnroadPrice
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOnroadPriceUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importOnroadPriceUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importOnroadPriceUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importOnroadPriceUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/dealership/onroad`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importOnroadPrice
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOnroadPriceUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importOnroadPriceUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importOnroadPriceUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importOnroadPriceUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/dealership/onroad`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importOnroadPrice
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOnroadPriceUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importOnroadPriceUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importOnroadPriceUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importOnroadPriceUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/dealership/onroad`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importOnroadPrice
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOnroadPriceUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importOnroadPriceUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importOnroadPriceUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importOnroadPriceUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/dealership/onroad`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importOnroadPrice
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOnroadPriceUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importOnroadPriceUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importOnroadPriceUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importOnroadPriceUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/dealership/onroad`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importOnroadPrice
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOnroadPriceUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importOnroadPriceUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importOnroadPriceUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importOnroadPriceUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/dealership/onroad`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importOnroadPrice
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOnroadPriceUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importOnroadPriceUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importOnroadPriceUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importOnroadPriceUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/dealership/onroad`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSalesManagers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSalesManagersUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSalesManagersUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSalesManagersUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSalesManagersUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/dealership/salesmanager`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSalesManagers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSalesManagersUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSalesManagersUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSalesManagersUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSalesManagersUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/dealership/salesmanager`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSalesManagers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSalesManagersUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSalesManagersUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSalesManagersUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSalesManagersUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/dealership/salesmanager`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSalesManagers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSalesManagersUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSalesManagersUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSalesManagersUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSalesManagersUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/dealership/salesmanager`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSalesManagers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSalesManagersUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSalesManagersUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSalesManagersUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSalesManagersUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/dealership/salesmanager`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSalesManagers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSalesManagersUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSalesManagersUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSalesManagersUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSalesManagersUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/dealership/salesmanager`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSalesManagers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSalesManagersUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSalesManagersUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSalesManagersUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSalesManagersUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/dealership/salesmanager`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUserDlrMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUserDlrMapUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUserDlrMapUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUserDlrMapUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUserDlrMapUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/dealership/userDealerMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUserDlrMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUserDlrMapUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUserDlrMapUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUserDlrMapUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUserDlrMapUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/dealership/userDealerMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUserDlrMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUserDlrMapUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUserDlrMapUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUserDlrMapUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUserDlrMapUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/dealership/userDealerMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUserDlrMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUserDlrMapUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUserDlrMapUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUserDlrMapUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUserDlrMapUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/dealership/userDealerMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUserDlrMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUserDlrMapUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUserDlrMapUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUserDlrMapUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUserDlrMapUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/dealership/userDealerMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUserDlrMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUserDlrMapUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUserDlrMapUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUserDlrMapUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUserDlrMapUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/dealership/userDealerMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUserDlrMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUserDlrMapUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUserDlrMapUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUserDlrMapUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUserDlrMapUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/dealership/userDealerMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsersUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsersUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsersUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsersUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/dealership/user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsersUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsersUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsersUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsersUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/dealership/user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsersUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsersUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsersUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsersUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/dealership/user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsersUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsersUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsersUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsersUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/dealership/user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsersUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsersUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsersUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsersUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/dealership/user`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsersUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsersUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsersUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsersUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/dealership/user`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsersUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsersUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsersUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsersUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/dealership/user`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsrBrandMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsrBrandMapUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsrBrandMapUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsrBrandMapUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsrBrandMapUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/dealership/userBrandMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsrBrandMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsrBrandMapUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsrBrandMapUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsrBrandMapUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsrBrandMapUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/dealership/userBrandMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsrBrandMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsrBrandMapUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsrBrandMapUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsrBrandMapUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsrBrandMapUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/dealership/userBrandMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsrBrandMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsrBrandMapUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsrBrandMapUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsrBrandMapUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsrBrandMapUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/dealership/userBrandMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsrBrandMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsrBrandMapUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsrBrandMapUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsrBrandMapUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsrBrandMapUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/dealership/userBrandMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsrBrandMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsrBrandMapUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsrBrandMapUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsrBrandMapUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsrBrandMapUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/dealership/userBrandMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importUsrBrandMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importUsrBrandMapUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importUsrBrandMapUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importUsrBrandMapUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importUsrBrandMapUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["X-AUTH-TOKEN"]) {
            headers = headers.set('X-AUTH-TOKEN', this.configuration.apiKeys["X-AUTH-TOKEN"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/dealership/userBrandMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}